/* MW Fitness — mejoras del carrito (lateral y página /cart)
   1) Campo de código de descuento que sí se aplica.
   2) Lista de beneficios + medios de pago reales.
   3) Un solo botón: FINALIZAR COMPRA (respetando la casilla de Términos).
   El carrito se redibuja por AJAX, así que todo se re-aplica con MutationObserver. */
(function () {
  'use strict';

  var MARCA = 'data-mwf-carrito';

  // Medios que la tienda SÍ cobra hoy. Plin no existe en Mercado Pago:
  // anunciarlo sería ofrecer algo que no se puede cumplir.
  var BENEFICIOS = [
    'Envío GRATIS desde S/ 79.90 — todo el Perú',
    'Contra entrega S/ 15 — Lima y provincias',
    'Retiro gratis en tienda — Gamarra',
    'Cambios y devoluciones — 3 días'
  ];
  var MEDIOS = ['Tarjetas', 'Yape', 'PagoEfectivo', 'Depósito', 'Contra entrega'];

  function texto(el) {
    return (el && (el.textContent || el.value) || '').trim();
  }

  /* ---------- 1. Código de descuento ---------- */
  function ponerDescuento(pie) {
    if (pie.querySelector('.mwf-desc')) return;

    var caja = document.createElement('div');
    caja.className = 'mwf-desc';

    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'mwf-desc__input';
    input.placeholder = 'Código de descuento';
    input.autocomplete = 'off';
    input.setAttribute('aria-label', 'Código de descuento');

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'mwf-desc__btn';
    boton.textContent = 'Aplicar';

    var aviso = document.createElement('div');
    aviso.className = 'mwf-desc__aviso';

    function aplicar() {
      var codigo = (input.value || '').trim();
      if (!codigo) {
        aviso.textContent = 'Escribe un código.';
        aviso.className = 'mwf-desc__aviso mwf-desc__aviso--err';
        return;
      }
      // Vía oficial de Shopify: /discount/CODIGO guarda el descuento en la sesión
      // y redirige. Así el importe con descuento ya sale en el checkout.
      aviso.textContent = 'Aplicando…';
      aviso.className = 'mwf-desc__aviso';
      try { sessionStorage.setItem('mwf_desc', codigo); } catch (e) {}
      window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart';
    }

    boton.addEventListener('click', aplicar);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); aplicar(); }
    });

    caja.appendChild(input);
    caja.appendChild(boton);

    var envoltorio = document.createElement('div');
    envoltorio.className = 'mwf-desc__wrap';
    envoltorio.appendChild(caja);
    envoltorio.appendChild(aviso);

    // Va arriba del subtotal, como en el diseño aprobado.
    var precio = pie.querySelector('.ajaxcart__footer-price, .cart-total__price, .cart-subtotal');
    if (precio && precio.parentNode === pie) pie.insertBefore(envoltorio, precio);
    else pie.insertBefore(envoltorio, pie.firstChild);

    // Si ya se aplicó un código en esta sesión, lo recordamos.
    try {
      var previo = sessionStorage.getItem('mwf_desc');
      if (previo) {
        input.value = previo;
        aviso.textContent = 'Código aplicado: ' + previo + '. Verás el descuento en el pago.';
        aviso.className = 'mwf-desc__aviso mwf-desc__aviso--ok';
      }
    } catch (e) {}
  }

  /* ---------- 2. Beneficios y medios de pago ---------- */
  function ponerBeneficios(pie) {
    if (pie.querySelector('.mwf-benef')) return;

    var caja = document.createElement('ul');
    caja.className = 'mwf-benef';

    BENEFICIOS.forEach(function (t) {
      var li = document.createElement('li');
      li.textContent = t;
      caja.appendChild(li);
    });

    var li = document.createElement('li');
    li.className = 'mwf-benef__pagos';
    var etiqueta = document.createElement('span');
    etiqueta.textContent = 'Aceptamos ';
    li.appendChild(etiqueta);
    MEDIOS.forEach(function (m) {
      var chip = document.createElement('span');
      chip.className = 'mwf-chip';
      chip.textContent = m;
      li.appendChild(chip);
    });
    caja.appendChild(li);

    var botones = pie.querySelector('.ajaxcart__footer-buttons, .cart-total__buttons');
    if (botones && botones.parentNode) botones.parentNode.insertBefore(caja, botones);
    else pie.appendChild(caja);
  }

  /* ---------- 3. Un solo botón ---------- */
  function unSoloBoton(pie) {
    var zona = pie.querySelector('.ajaxcart__footer-buttons, .cart-total__buttons');
    if (!zona || zona.getAttribute('data-mwf-btn')) return;

    var botones = [].slice.call(zona.querySelectorAll('button, input[type="submit"], a.btn'));
    if (!botones.length) return;

    // El de pago es el que lleva name="checkout" o la clase del tema.
    var pagar = botones.filter(function (b) {
      return b.name === 'checkout' ||
             /checkout/i.test(b.className) ||
             /pagar|finalizar|checkout/i.test(texto(b));
    })[0] || botones[0];

    botones.forEach(function (b) {
      if (b === pagar) return;
      // "Continuar comprando" / "Ver carrito": fuera, el cliente pidió un solo botón.
      var cont = b.closest ? b.closest('.button-cart') : null;
      (cont || b).style.display = 'none';
    });

    if (pagar.tagName === 'INPUT') pagar.value = 'FINALIZAR COMPRA';
    else pagar.textContent = 'FINALIZAR COMPRA';
    pagar.classList.add('mwf-btn-pagar');

    // Si hay código escrito y aún no se aplicó, lo aplicamos antes de ir al pago.
    pagar.addEventListener('click', function (e) {
      var input = document.querySelector('.mwf-desc__input');
      var codigo = input ? (input.value || '').trim() : '';
      var yaAplicado = '';
      try { yaAplicado = sessionStorage.getItem('mwf_desc') || ''; } catch (err) {}
      if (codigo && codigo !== yaAplicado) {
        e.preventDefault();
        e.stopPropagation();
        try { sessionStorage.setItem('mwf_desc', codigo); } catch (err) {}
        window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/checkout';
      }
    }, true);

    zona.setAttribute('data-mwf-btn', '1');
  }

  /* ---------- aplicar en todo pie de carrito ---------- */
  function aplicar() {
    // .ajaxcart__footer = carrito lateral · .cart-total = página /cart
    var pies = [].slice.call(document.querySelectorAll('.ajaxcart__footer, .cart-total'));
    pies.forEach(function (pie) {
      try {
        ponerDescuento(pie);
        ponerBeneficios(pie);
        unSoloBoton(pie);
        pie.setAttribute(MARCA, '1');
      } catch (e) {}
    });
  }

  function iniciar() {
    aplicar();
    // El carrito se redibuja por AJAX: hay que volver a aplicarlo.
    var obs = new MutationObserver(function () {
      clearTimeout(window.__mwfCarritoT);
      window.__mwfCarritoT = setTimeout(aplicar, 120);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();